import { render, staticRenderFns } from "./videoinfo.vue?vue&type=template&id=0c7eb41e&scoped=true&"
import script from "./videoinfo.vue?vue&type=script&lang=js&"
export * from "./videoinfo.vue?vue&type=script&lang=js&"
import style0 from "./videoinfo.vue?vue&type=style&index=0&id=0c7eb41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7eb41e",
  null
  
)

export default component.exports